import { z } from "zod";

export const ObjectMeta = z.object({
  name: z.string(),
  description: z.string().optional(),
});

export type ObjectMeta = z.infer<typeof ObjectMeta>;
